import { Form, Select } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';

import { Part } from '@/core/domain/operational/Parts/Parts.types';

import { ColumnsType } from '@/components/_common/Table';
import { getTableScrollX } from '@/utils/table';
import { useDiagnosticParts } from '@/core/domain/workorder/Diagnostics/Diagnostics.hooks';
import { InfiniteTable } from '@/components/_common';
import { flatRequestPages } from '@/utils/request';

function DiagnosticsPartList() {
  const intl = useIntl();

  const {
    data,
    isFetching: loading,
    hasNextPage,
    fetchNextPage,
  } = useDiagnosticParts({
    rows: 10,
  });

  const parts = flatRequestPages(data);

  const columns: ColumnsType<Part> = [
    {
      title: intl.formatMessage({
        id: 'diagnostics.form.partsList.header.description',
      }),
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      width: 150,
    },
    {
      title: intl.formatMessage({
        id: 'diagnostics.form.partsList.header.status',
      }),
      width: 120,
      key: 'status',
      render: (_, record, index) => (
        <>
          <Form.Item
            hidden
            name={['items', index, 'partId']}
            initialValue={record.id}
          />
          <Form.Item noStyle name={['items', index, 'status']}>
            <Select
              style={{ width: '100%' }}
              options={[
                {
                  value: 'domain.enums.diagnostic_status.ok',
                  label: intl.formatMessage({
                    id: 'diagnostics.form.partsList.status.ok',
                  }),
                },
                {
                  value: 'domain.enums.diagnostic_status.change',
                  label: intl.formatMessage({
                    id: 'diagnostics.form.partsList.status.replace',
                  }),
                },
                {
                  value: 'domain.enums.diagnostic_status.repair',
                  label: intl.formatMessage({
                    id: 'diagnostics.form.partsList.status.repair',
                  }),
                },
              ]}
            />
          </Form.Item>
        </>
      ),
    },
  ];

  return (
    <>
      <h2>
        <FormattedMessage id="diagnostics.form.partsList" />
      </h2>
      <InfiniteTable<Part>
        rowKey={(row) => row.id}
        loading={loading}
        columns={columns}
        dataSource={parts}
        pagination={false}
        scroll={{ x: getTableScrollX(columns) }}
        hasNextPage={hasNextPage}
        fetchNextPage={fetchNextPage}
      />
    </>
  );
}

export default DiagnosticsPartList;
